<lib-cdw-checkbox data-testid="search-grid-row-select" (click)="onClick($event)" [checked]="!!(isSelected$ | async)" [disabled]="!!(selectAll$ | async)">
</lib-cdw-checkbox>
